export default defineNuxtRouteMiddleware((to) => {
  const target = commitmentStepFromParam(to.params.step)
  if (target === 1) return

  const { reached, completed } = useCommitmentProgress().value
  const allowed = target === 3 ? completed : reached >= 2 && !completed
  if (allowed) return

  return navigateTo(commitmentStepLocation(to.path, to.query, 1), {
    replace: true,
  })
})
